export const supportTranslations = {
  en: {
    'support.back': 'Back',
    'support.title': 'Support Center',
    'support.subtitle': 'Get help with your account and transactions',
    'support.responseTime': '24hr Response Time',
    'support.systemStatus': 'System Status',
    'support.allSystemsOperational': 'All systems operational',
    'support.helpCenter': 'Help Center',
    'support.helpCenterDesc': 'Browse FAQs and guides',
    'support.emailSupport': 'Email Support',
    'support.submitTicket': 'Submit Ticket',
    'support.submitTicketDesc': 'Create a support request',
    'support.ticketsTitle': 'Support Tickets',
    'support.ticketsDesc': 'Submit new tickets or view your existing support requests',
    'support.newTicket': 'New Ticket',
    'support.myTickets': 'My Tickets',
    'support.guestSubmission': 'Guest Submission',
    'support.guestSubmissionDesc': "You're submitting as a guest. {loginLink} to track your tickets.",
    'support.login': 'Log in',
    'support.category': 'Category',
    'support.priority': 'Priority',
    'support.subject': 'Subject',
    'support.subjectPlaceholder': 'Brief description of your issue',
    'support.message': 'Message',
    'support.messagePlaceholder': 'Please provide detailed information about your issue...',
    'support.submitting': 'Submitting...',
    'support.submit': 'Submit Ticket',
    'support.pleaseLogin': 'Please {loginLink} to view your tickets.',
    'support.loadingTickets': 'Loading your tickets...',
    'support.noTickets': "You haven't submitted any tickets yet",
    'support.createFirstTicket': 'Create Your First Ticket',
    'support.ticketDetail': 'Ticket #{ticketNumber}',
    'support.you': 'You',
    'support.resolvedMessage': 'This ticket has been resolved. If you need further assistance, please create a new ticket.',
    'support.toast.validationError': 'Validation Error',
    'support.toast.validationErrorDesc': 'Please provide both subject and message',
    'support.toast.success': 'Success',
    'support.toast.successDesc': "Your support ticket has been submitted. We'll respond within 24 hours.",
    'support.toast.ticketSubmitted': 'Ticket Submitted',
    'support.toast.ticketSubmittedDesc': 'Your ticket #{ticketNumber} has been submitted. Please log in to track your tickets.',
    'support.toast.ticketSubmittedGuest': 'Your ticket has been submitted. Please log in to track your tickets.',
    'support.toast.authRequired': 'Authentication Required',
    'support.toast.authRequiredDesc': 'Please log in to submit a support ticket, or try again as a guest.',
    'support.toast.error': 'Error',
    'support.toast.errorDesc': 'Failed to submit support ticket. Please try again.',
  },
  es: {
    'support.back': 'Atrás',
    'support.title': 'Centro de Soporte',
    'support.subtitle': 'Obtén ayuda con tu cuenta y transacciones',
    'support.responseTime': 'Tiempo de Respuesta de 24h',
    'support.systemStatus': 'Estado del Sistema',
    'support.allSystemsOperational': 'Todos los sistemas operativos',
    'support.helpCenter': 'Centro de Ayuda',
    'support.helpCenterDesc': 'Consulta las preguntas frecuentes y las guías',
    'support.emailSupport': 'Soporte por Correo Electrónico',
    'support.submitTicket': 'Enviar Ticket',
    'support.submitTicketDesc': 'Crea una solicitud de soporte',
    'support.ticketsTitle': 'Tickets de Soporte',
    'support.ticketsDesc': 'Envía nuevos tickets o consulta tus solicitudes de soporte existentes',
    'support.newTicket': 'Nuevo Ticket',
    'support.myTickets': 'Mis Tickets',
    'support.guestSubmission': 'Envío como Invitado',
    'support.guestSubmissionDesc': 'Estás enviando como invitado. {loginLink} para seguir tus tickets.',
    'support.login': 'Inicia sesión',
    'support.category': 'Categoría',
    'support.priority': 'Prioridad',
    'support.subject': 'Asunto',
    'support.subjectPlaceholder': 'Breve descripción de tu problema',
    'support.message': 'Mensaje',
    'support.messagePlaceholder': 'Proporciona información detallada sobre tu problema...',
    'support.submitting': 'Enviando...',
    'support.submit': 'Enviar Ticket',
    'support.pleaseLogin': 'Por favor, {loginLink} para ver tus tickets.',
    'support.loadingTickets': 'Cargando tus tickets...',
    'support.noTickets': 'Aún no has enviado ningún ticket',
    'support.createFirstTicket': 'Crea Tu Primer Ticket',
    'support.ticketDetail': 'Ticket #{ticketNumber}',
    'support.you': 'Tú',
    'support.resolvedMessage': 'Este ticket ha sido resuelto. Si necesitas más ayuda, por favor, crea un nuevo ticket.',
    'support.toast.validationError': 'Error de Validación',
    'support.toast.validationErrorDesc': 'Por favor, proporciona tanto el asunto como el mensaje',
    'support.toast.success': 'Éxito',
    'support.toast.successDesc': 'Tu ticket de soporte ha sido enviado. Responderemos en 24 horas.',
    'support.toast.ticketSubmitted': 'Ticket Enviado',
    'support.toast.ticketSubmittedDesc': 'Tu ticket #{ticketNumber} ha sido enviado. Por favor, inicia sesión para seguir tus tickets.',
    'support.toast.ticketSubmittedGuest': 'Tu ticket ha sido enviado. Por favor, inicia sesión para seguir tus tickets.',
    'support.toast.authRequired': 'Autenticación Requerida',
    'support.toast.authRequiredDesc': 'Por favor, inicia sesión para enviar un ticket de soporte, o inténtalo de nuevo como invitado.',
    'support.toast.error': 'Error',
    'support.toast.errorDesc': 'No se pudo enviar el ticket de soporte. Por favor, inténtalo de nuevo.',
  },
  fr: {
    'support.back': 'Retour',
    'support.title': 'Centre de support',
    'support.subtitle': 'Obtenez de l\'aide avec votre compte et vos transactions',
    'support.responseTime': 'Délai de réponse de 24h',
    'support.systemStatus': 'État du système',
    'support.allSystemsOperational': 'Tous les systèmes sont opérationnels',
    'support.helpCenter': 'Centre d\'aide',
    'support.helpCenterDesc': 'Parcourez les FAQ et guides',
    'support.emailSupport': 'Support par e-mail',
    'support.submitTicket': 'Soumettre un ticket',
    'support.submitTicketDesc': 'Créer une demande de support',
    'support.ticketsTitle': 'Tickets de support',
    'support.ticketsDesc': 'Soumettez de nouveaux tickets ou consultez vos demandes de support existantes',
    'support.newTicket': 'Nouveau ticket',
    'support.myTickets': 'Mes tickets',
    'support.guestSubmission': 'Soumission invité',
    'support.guestSubmissionDesc': 'Vous soumettez en tant qu\'invité. {loginLink} pour suivre vos tickets.',
    'support.login': 'Se connecter',
    'support.category': 'Catégorie',
    'support.priority': 'Priorité',
    'support.subject': 'Sujet',
    'support.subjectPlaceholder': 'Brève description de votre problème',
    'support.message': 'Message',
    'support.messagePlaceholder': 'Veuillez fournir des informations détaillées sur votre problème...',
    'support.submitting': 'Soumission...',
    'support.submit': 'Soumettre le ticket',
    'support.pleaseLogin': 'Veuillez {loginLink} pour voir vos tickets.',
    'support.loadingTickets': 'Chargement de vos tickets...',
    'support.noTickets': 'Vous n\'avez pas encore soumis de tickets',
    'support.createFirstTicket': 'Créez votre premier ticket',
    'support.ticketDetail': 'Ticket #{ticketNumber}',
    'support.you': 'Vous',
    'support.resolvedMessage': 'Ce ticket a été résolu. Si vous avez besoin d\'une aide supplémentaire, veuillez créer un nouveau ticket.',
    'support.toast.validationError': 'Erreur de validation',
    'support.toast.validationErrorDesc': 'Veuillez fournir à la fois le sujet et le message',
    'support.toast.success': 'Succès',
    'support.toast.successDesc': 'Votre ticket de support a été soumis. Nous répondrons dans les 24 heures.',
    'support.toast.ticketSubmitted': 'Ticket soumis',
    'support.toast.ticketSubmittedDesc': 'Votre ticket #{ticketNumber} a été soumis. Veuillez vous connecter pour suivre vos tickets.',
    'support.toast.ticketSubmittedGuest': 'Votre ticket a été soumis. Veuillez vous connecter pour suivre vos tickets.',
    'support.toast.authRequired': 'Authentification requise',
    'support.toast.authRequiredDesc': 'Veuillez vous connecter pour soumettre un ticket de support, ou réessayez en tant qu\'invité.',
    'support.toast.error': 'Erreur',
    'support.toast.errorDesc': 'Échec de la soumission du ticket de support. Veuillez réessayer.',
  },
  sq: {
    'support.back': 'Kthehu',
    'support.title': 'Qendra e Mbështetjes',
    'support.subtitle': 'Merrni ndihmë me llogarinë dhe transaksionet tuaja',
    'support.responseTime': 'Koha e Përgjigjes 24 orë',
    'support.systemStatus': 'Statusi i Sistemit',
    'support.allSystemsOperational': 'Të gjitha sistemet janë operacionale',
    'support.helpCenter': 'Qendra e Ndihmës',
    'support.helpCenterDesc': 'Shfletoni FAQ-të dhe udhëzuesit',
    'support.emailSupport': 'Mbështetje me Email',
    'support.submitTicket': 'Paraqit Biletë',
    'support.submitTicketDesc': 'Krijoni një kërkesë mbështetjeje',
    'support.ticketsTitle': 'Biletat e Mbështetjes',
    'support.ticketsDesc': 'Paraqitni biletat e reja ose shikoni kërkesat tuaja ekzistuese të mbështetjes',
    'support.newTicket': 'Biletë e Re',
    'support.myTickets': 'Biletat e Mia',
    'support.guestSubmission': 'Paraqitje si Mysafir',
    'support.guestSubmissionDesc': 'Po paraqisni si mysafir. {loginLink} për të ndjekur biletat tuaja.',
    'support.login': 'Hyr',
    'support.category': 'Kategoria',
    'support.priority': 'Prioriteti',
    'support.subject': 'Subjekti',
    'support.subjectPlaceholder': 'Përshkrim i shkurtër i problemit tuaj',
    'support.message': 'Mesazhi',
    'support.messagePlaceholder': 'Ju lutem jepni informacion të detajuar për problemit tuaj...',
    'support.submitting': 'Duke paraqitur...',
    'support.submit': 'Paraqit Biletë',
    'support.pleaseLogin': 'Ju lutem {loginLink} për të parë biletat tuaja.',
    'support.loadingTickets': 'Duke ngarkuar biletat tuaja...',
    'support.noTickets': 'Ende nuk keni paraqitur asnjë biletë',
    'support.createFirstTicket': 'Krijoni Biletën tuaj të Parë',
    'support.ticketDetail': 'Biletë #{ticketNumber}',
    'support.you': 'Ju',
    'support.resolvedMessage': 'Kjo biletë është zgjidhur. Nëse keni nevojë për ndihmë të mëtejshme, ju lutem krijoni një biletë të re.',
    'support.toast.validationError': 'Gabim Validimi',
    'support.toast.validationErrorDesc': 'Ju lutem jepni si subjektin ashtu edhe mesazhin',
    'support.toast.success': 'Sukses',
    'support.toast.successDesc': 'Biletëja juaj e mbështetjes është paraqitur. Ne do të përgjigjemi brenda 24 orëve.',
    'support.toast.ticketSubmitted': 'Biletë e Paraqitur',
    'support.toast.ticketSubmittedDesc': 'Biletëja juaj #{ticketNumber} është paraqitur. Ju lutem hyni për të ndjekur biletat tuaja.',
    'support.toast.ticketSubmittedGuest': 'Biletëja juaj është paraqitur. Ju lutem hyni për të ndjekur biletat tuaja.',
    'support.toast.authRequired': 'Kërkohet Autentifikim',
    'support.toast.authRequiredDesc': 'Ju lutem hyni për të paraqitur një biletë mbështetjeje, ose provoni përsëri si mysafir.',
    'support.toast.error': 'Gabim',
    'support.toast.errorDesc': 'Dështoi paraqitja e biletës së mbështetjes. Ju lutem provoni përsëri.',
  },
  ru: {
    'support.back': 'Назад',
    'support.title': 'Центр поддержки',
    'support.subtitle': 'Получите помощь с вашим аккаунтом и транзакциями',
    'support.responseTime': 'Время ответа 24 часа',
    'support.systemStatus': 'Статус системы',
    'support.allSystemsOperational': 'Все системы работают',
    'support.helpCenter': 'Центр помощи',
    'support.helpCenterDesc': 'Просмотрите FAQ и руководства',
    'support.emailSupport': 'Поддержка по email',
    'support.submitTicket': 'Отправить тикет',
    'support.submitTicketDesc': 'Создать запрос в поддержку',
    'support.ticketsTitle': 'Тикеты поддержки',
    'support.ticketsDesc': 'Отправьте новые тикеты или просмотрите ваши существующие запросы в поддержку',
    'support.newTicket': 'Новый тикет',
    'support.myTickets': 'Мои тикеты',
    'support.guestSubmission': 'Отправка как гость',
    'support.guestSubmissionDesc': 'Вы отправляете как гость. {loginLink} для отслеживания ваших тикетов.',
    'support.login': 'Войти',
    'support.category': 'Категория',
    'support.priority': 'Приоритет',
    'support.subject': 'Тема',
    'support.subjectPlaceholder': 'Краткое описание вашей проблемы',
    'support.message': 'Сообщение',
    'support.messagePlaceholder': 'Пожалуйста, предоставьте подробную информацию о вашей проблеме...',
    'support.submitting': 'Отправка...',
    'support.submit': 'Отправить тикет',
    'support.pleaseLogin': 'Пожалуйста, {loginLink} для просмотра ваших тикетов.',
    'support.loadingTickets': 'Загрузка ваших тикетов...',
    'support.noTickets': 'Вы еще не отправили ни одного тикета',
    'support.createFirstTicket': 'Создайте ваш первый тикет',
    'support.ticketDetail': 'Тикет #{ticketNumber}',
    'support.you': 'Вы',
    'support.resolvedMessage': 'Этот тикет был решен. Если вам нужна дополнительная помощь, пожалуйста, создайте новый тикет.',
    'support.toast.validationError': 'Ошибка валидации',
    'support.toast.validationErrorDesc': 'Пожалуйста, укажите тему и сообщение',
    'support.toast.success': 'Успех',
    'support.toast.successDesc': 'Ваш тикет поддержки отправлен. Мы ответим в течение 24 часов.',
    'support.toast.ticketSubmitted': 'Тикет отправлен',
    'support.toast.ticketSubmittedDesc': 'Ваш тикет #{ticketNumber} отправлен. Пожалуйста, войдите для отслеживания ваших тикетов.',
    'support.toast.ticketSubmittedGuest': 'Ваш тикет отправлен. Пожалуйста, войдите для отслеживания ваших тикетов.',
    'support.toast.authRequired': 'Требуется аутентификация',
    'support.toast.authRequiredDesc': 'Пожалуйста, войдите для отправки тикета поддержки или попробуйте снова как гость.',
    'support.toast.error': 'Ошибка',
    'support.toast.errorDesc': 'Не удалось отправить тикет поддержки. Пожалуйста, попробуйте снова.',
  },
  pt: {
    'support.back': 'Voltar',
    'support.title': 'Centro de Suporte',
    'support.subtitle': 'Obtenha ajuda com sua conta e transações',
    'support.responseTime': 'Tempo de Resposta de 24h',
    'support.systemStatus': 'Status do Sistema',
    'support.allSystemsOperational': 'Todos os sistemas operacionais',
    'support.helpCenter': 'Centro de Ajuda',
    'support.helpCenterDesc': 'Navegue por FAQs e guias',
    'support.emailSupport': 'Suporte por Email',
    'support.submitTicket': 'Enviar Ticket',
    'support.submitTicketDesc': 'Criar uma solicitação de suporte',
    'support.ticketsTitle': 'Tickets de Suporte',
    'support.ticketsDesc': 'Envie novos tickets ou visualize suas solicitações de suporte existentes',
    'support.newTicket': 'Novo Ticket',
    'support.myTickets': 'Meus Tickets',
    'support.guestSubmission': 'Envio como Convidado',
    'support.guestSubmissionDesc': 'Você está enviando como convidado. {loginLink} para rastrear seus tickets.',
    'support.login': 'Fazer login',
    'support.category': 'Categoria',
    'support.priority': 'Prioridade',
    'support.subject': 'Assunto',
    'support.subjectPlaceholder': 'Breve descrição do seu problema',
    'support.message': 'Mensagem',
    'support.messagePlaceholder': 'Por favor, forneça informações detalhadas sobre seu problema...',
    'support.submitting': 'Enviando...',
    'support.submit': 'Enviar Ticket',
    'support.pleaseLogin': 'Por favor, {loginLink} para visualizar seus tickets.',
    'support.loadingTickets': 'Carregando seus tickets...',
    'support.noTickets': 'Você ainda não enviou nenhum ticket',
    'support.createFirstTicket': 'Crie Seu Primeiro Ticket',
    'support.ticketDetail': 'Ticket #{ticketNumber}',
    'support.you': 'Você',
    'support.resolvedMessage': 'Este ticket foi resolvido. Se precisar de mais assistência, crie um novo ticket.',
    'support.toast.validationError': 'Erro de Validação',
    'support.toast.validationErrorDesc': 'Por favor, forneça assunto e mensagem',
    'support.toast.success': 'Sucesso',
    'support.toast.successDesc': 'Seu ticket de suporte foi enviado. Responderemos em até 24 horas.',
    'support.toast.ticketSubmitted': 'Ticket Enviado',
    'support.toast.ticketSubmittedDesc': 'Seu ticket #{ticketNumber} foi enviado. Por favor, faça login para rastrear seus tickets.',
    'support.toast.ticketSubmittedGuest': 'Seu ticket foi enviado. Por favor, faça login para rastrear seus tickets.',
    'support.toast.authRequired': 'Autenticação Necessária',
    'support.toast.authRequiredDesc': 'Por favor, faça login para enviar um ticket de suporte ou tente novamente como convidado.',
    'support.toast.error': 'Erro',
    'support.toast.errorDesc': 'Falha ao enviar ticket de suporte. Por favor, tente novamente.',
  },
  el: {
    'support.back': 'Πίσω',
    'support.title': 'Κέντρο Υποστήριξης',
    'support.subtitle': 'Λάβετε βοήθεια για τον λογαριασμό και τις συναλλαγές σας',
    'support.responseTime': 'Χρόνος Απάντησης 24ωρ',
    'support.systemStatus': 'Κατάσταση Συστήματος',
    'support.allSystemsOperational': 'Όλα τα συστήματα λειτουργούν',
    'support.helpCenter': 'Κέντρο Βοήθειας',
    'support.helpCenterDesc': 'Περιηγηθείτε σε FAQs και οδηγούς',
    'support.emailSupport': 'Υποστήριξη Email',
    'support.submitTicket': 'Υποβολή Αιτήματος',
    'support.submitTicketDesc': 'Δημιουργήστε ένα αίτημα υποστήριξης',
    'support.ticketsTitle': 'Αιτήματα Υποστήριξης',
    'support.ticketsDesc': 'Υποβάλετε νέα αιτήματα ή δείτε τα υπάρχοντα αιτήματα υποστήριξής σας',
    'support.newTicket': 'Νέο Αίτημα',
    'support.myTickets': 'Τα Αιτήματά Μου',
    'support.guestSubmission': 'Υποβολή Επισκέπτη',
    'support.guestSubmissionDesc': 'Υποβάλλετε ως επισκέπτης. {loginLink} για να παρακολουθήσετε τα αιτήματά σας.',
    'support.login': 'Σύνδεση',
    'support.category': 'Κατηγορία',
    'support.priority': 'Προτεραιότητα',
    'support.subject': 'Θέμα',
    'support.subjectPlaceholder': 'Σύντομη περιγραφή του προβλήματός σας',
    'support.message': 'Μήνυμα',
    'support.messagePlaceholder': 'Παρακαλώ δώστε λεπτομερείς πληροφορίες σχετικά με το πρόβλημά σας...',
    'support.submitting': 'Υποβολή...',
    'support.submit': 'Υποβολή Αιτήματος',
    'support.pleaseLogin': 'Παρακαλώ {loginLink} για να δείτε τα αιτήματά σας.',
    'support.loadingTickets': 'Φόρτωση των αιτημάτων σας...',
    'support.noTickets': 'Δεν έχετε υποβάλει ακόμα κανένα αίτημα',
    'support.createFirstTicket': 'Δημιουργήστε το Πρώτο Σας Αίτημα',
    'support.ticketDetail': 'Αίτημα #{ticketNumber}',
    'support.you': 'Εσείς',
    'support.resolvedMessage': 'Αυτό το αίτημα έχει επιλυθεί. Εάν χρειάζεστε περαιτέρω βοήθεια, παρακαλώ δημιουργήστε ένα νέο αίτημα.',
    'support.toast.validationError': 'Σφάλμα Επικύρωσης',
    'support.toast.validationErrorDesc': 'Παρακαλώ δώστε τόσο το θέμα όσο και το μήνυμα',
    'support.toast.success': 'Επιτυχία',
    'support.toast.successDesc': 'Το αίτημα υποστήριξής σας υποβλήθηκε. Θα απαντήσουμε εντός 24 ωρών.',
    'support.toast.ticketSubmitted': 'Το Αίτημα Υποβλήθηκε',
    'support.toast.ticketSubmittedDesc': 'Το αίτημά σας #{ticketNumber} υποβλήθηκε. Παρακαλώ συνδεθείτε για να παρακολουθήσετε τα αιτήματά σας.',
    'support.toast.ticketSubmittedGuest': 'Το αίτημά σας υποβλήθηκε. Παρακαλώ συνδεθείτε για να παρακολουθήσετε τα αιτήματά σας.',
    'support.toast.authRequired': 'Απαιτείται Πιστοποίηση',
    'support.toast.authRequiredDesc': 'Παρακαλώ συνδεθείτε για να υποβάλετε ένα αίτημα υποστήριξης, ή δοκιμάστε ξανά ως επισκέπτης.',
    'support.toast.error': 'Σφάλμα',
    'support.toast.errorDesc': 'Αποτυχία υποβολής αιτήματος υποστήριξης. Παρακαλώ δοκιμάστε ξανά.',
  },
  de: {
    'support.back': 'Zurück',
    'support.title': 'Support-Zentrum',
    'support.subtitle': 'Hilfe zu Ihrem Konto und Ihren Transaktionen erhalten',
    'support.responseTime': '24-Stunden-Antwortzeit',
    'support.systemStatus': 'Systemstatus',
    'support.allSystemsOperational': 'Alle Systeme funktionieren',
    'support.helpCenter': 'Hilfezentrum',
    'support.helpCenterDesc': 'FAQs und Anleitungen durchsuchen',
    'support.emailSupport': 'E-Mail-Support',
    'support.submitTicket': 'Ticket einreichen',
    'support.submitTicketDesc': 'Eine Support-Anfrage erstellen',
    'support.ticketsTitle': 'Support-Tickets',
    'support.ticketsDesc': 'Neue Tickets einreichen oder Ihre bestehenden Support-Anfragen anzeigen',
    'support.newTicket': 'Neues Ticket',
    'support.myTickets': 'Meine Tickets',
    'support.guestSubmission': 'Gast-Einreichung',
    'support.guestSubmissionDesc': 'Sie reichen als Gast ein. {loginLink}, um Ihre Tickets zu verfolgen.',
    'support.login': 'Anmelden',
    'support.category': 'Kategorie',
    'support.priority': 'Priorität',
    'support.subject': 'Betreff',
    'support.subjectPlaceholder': 'Kurze Beschreibung Ihres Problems',
    'support.message': 'Nachricht',
    'support.messagePlaceholder': 'Bitte geben Sie detaillierte Informationen zu Ihrem Problem an...',
    'support.submitting': 'Wird eingereicht...',
    'support.submit': 'Ticket einreichen',
    'support.pleaseLogin': 'Bitte {loginLink}, um Ihre Tickets anzuzeigen.',
    'support.loadingTickets': 'Ihre Tickets werden geladen...',
    'support.noTickets': 'Sie haben noch keine Tickets eingereicht',
    'support.createFirstTicket': 'Ihr erstes Ticket erstellen',
    'support.ticketDetail': 'Ticket #{ticketNumber}',
    'support.you': 'Sie',
    'support.resolvedMessage': 'Dieses Ticket wurde gelöst. Wenn Sie weitere Hilfe benötigen, erstellen Sie bitte ein neues Ticket.',
    'support.toast.validationError': 'Validierungsfehler',
    'support.toast.validationErrorDesc': 'Bitte geben Sie sowohl Betreff als auch Nachricht an',
    'support.toast.success': 'Erfolg',
    'support.toast.successDesc': 'Ihr Support-Ticket wurde eingereicht. Wir antworten innerhalb von 24 Stunden.',
    'support.toast.ticketSubmitted': 'Ticket eingereicht',
    'support.toast.ticketSubmittedDesc': 'Ihr Ticket #{ticketNumber} wurde eingereicht. Bitte melden Sie sich an, um Ihre Tickets zu verfolgen.',
    'support.toast.ticketSubmittedGuest': 'Ihr Ticket wurde eingereicht. Bitte melden Sie sich an, um Ihre Tickets zu verfolgen.',
    'support.toast.authRequired': 'Authentifizierung erforderlich',
    'support.toast.authRequiredDesc': 'Bitte melden Sie sich an, um ein Support-Ticket einzureichen, oder versuchen Sie es erneut als Gast.',
    'support.toast.error': 'Fehler',
    'support.toast.errorDesc': 'Support-Ticket konnte nicht eingereicht werden. Bitte versuchen Sie es erneut.',
  },
  ro: {
    'support.back': 'Înapoi',
    'support.title': 'Centru de Suport',
    'support.subtitle': 'Obțineți ajutor cu contul și tranzacțiile dvs.',
    'support.responseTime': 'Timp de Răspuns 24h',
    'support.systemStatus': 'Status Sistem',
    'support.allSystemsOperational': 'Toate sistemele sunt operaționale',
    'support.helpCenter': 'Centru de Ajutor',
    'support.helpCenterDesc': 'Răsfoiți întrebări frecvente și ghiduri',
    'support.emailSupport': 'Suport Email',
    'support.submitTicket': 'Trimite Tichet',
    'support.submitTicketDesc': 'Creați o solicitare de suport',
    'support.ticketsTitle': 'Tichete Suport',
    'support.ticketsDesc': 'Trimiteți tichete noi sau vizualizați solicitările dvs. de suport existente',
    'support.newTicket': 'Tichet Nou',
    'support.myTickets': 'Tichetele Mele',
    'support.guestSubmission': 'Trimitere Oaspete',
    'support.guestSubmissionDesc': 'Trimiți ca oaspete. {loginLink} pentru a urmări tichetele dvs.',
    'support.login': 'Conectați-vă',
    'support.category': 'Categorie',
    'support.priority': 'Prioritate',
    'support.subject': 'Subiect',
    'support.subjectPlaceholder': 'Descriere scurtă a problemei dvs.',
    'support.message': 'Mesaj',
    'support.messagePlaceholder': 'Vă rugăm să furnizați informații detaliate despre problema dvs...',
    'support.submitting': 'Se trimite...',
    'support.submit': 'Trimite Tichet',
    'support.pleaseLogin': 'Vă rugăm să {loginLink} pentru a vizualiza tichetele dvs.',
    'support.loadingTickets': 'Se încarcă tichetele dvs...',
    'support.noTickets': 'Nu ați trimis încă niciun tichet',
    'support.createFirstTicket': 'Creați Primul Dvs. Tichet',
    'support.ticketDetail': 'Tichet #{ticketNumber}',
    'support.you': 'Dvs.',
    'support.resolvedMessage': 'Acest tichet a fost rezolvat. Dacă aveți nevoie de asistență suplimentară, vă rugăm să creați un tichet nou.',
    'support.toast.validationError': 'Eroare de Validare',
    'support.toast.validationErrorDesc': 'Vă rugăm să furnizați atât subiectul cât și mesajul',
    'support.toast.success': 'Succes',
    'support.toast.successDesc': 'Tichetul dvs. de suport a fost trimis. Vom răspunde în termen de 24 de ore.',
    'support.toast.ticketSubmitted': 'Tichet Trimis',
    'support.toast.ticketSubmittedDesc': 'Tichetul dvs. #{ticketNumber} a fost trimis. Vă rugăm să vă conectați pentru a urmări tichetele dvs.',
    'support.toast.ticketSubmittedGuest': 'Tichetul dvs. a fost trimis. Vă rugăm să vă conectați pentru a urmări tichetele dvs.',
    'support.toast.authRequired': 'Autentificare Necesară',
    'support.toast.authRequiredDesc': 'Vă rugăm să vă conectați pentru a trimite un tichet de suport sau încercați din nou ca oaspete.',
    'support.toast.error': 'Eroare',
    'support.toast.errorDesc': 'Nu s-a putut trimite tichetul de suport. Vă rugăm să încercați din nou.',
  },
  sr: {
    'support.back': 'Назад',
    'support.title': 'Центар за подршку',
    'support.subtitle': 'Потражите помоћ у вези са вашим налогом и трансакцијама',
    'support.responseTime': 'Време одговора 24 сата',
    'support.systemStatus': 'Статус система',
    'support.allSystemsOperational': 'Сви системи су оперативни',
    'support.helpCenter': 'Центар за помоћ',
    'support.helpCenterDesc': 'Прегледајте честа питања и водиче',
    'support.emailSupport': 'Подршка путем имејла',
    'support.submitTicket': 'Пошаљи тикет',
    'support.submitTicketDesc': 'Креирајте захтев за подршку',
    'support.ticketsTitle': 'Тикети за подршку',
    'support.ticketsDesc': 'Пошаљите нове тикете или погледајте постојеће захтеве за подршку',
    'support.newTicket': 'Нови тикет',
    'support.myTickets': 'Моји тикети',
    'support.guestSubmission': 'Подношење као гост',
    'support.guestSubmissionDesc': 'Подносите као гост. {loginLink} да бисте пратили своје тикете.',
    'support.login': 'Пријавите се',
    'support.category': 'Категорија',
    'support.priority': 'Приоритет',
    'support.subject': 'Наслов',
    'support.subjectPlaceholder': 'Кратак опис вашег проблема',
    'support.message': 'Порука',
    'support.messagePlaceholder': 'Молимо вас да наведете детаљне информације о вашем проблему...',
    'support.submitting': 'Подношење...',
    'support.submit': 'Пошаљи тикет',
    'support.pleaseLogin': 'Молимо {loginLink} да бисте видели своје тикете.',
    'support.loadingTickets': 'Учитавање ваших тикета...',
    'support.noTickets': 'Још нисте поднели ниједан тикет',
    'support.createFirstTicket': 'Креирајте свој први тикет',
    'support.ticketDetail': 'Тикет #{ticketNumber}',
    'support.you': 'Ви',
    'support.resolvedMessage': 'Овај тикет је решен. Ако вам је потребна додатна помоћ, молимо вас да креирате нови тикет.',
    'support.toast.validationError': 'Грешка у валидацији',
    'support.toast.validationErrorDesc': 'Молимо унесите и наслов и поруку',
    'support.toast.success': 'Успех',
    'support.toast.successDesc': 'Ваш тикет за подршку је послат. Одговорићемо у року од 24 сата.',
    'support.toast.ticketSubmitted': 'Тикет послат',
    'support.toast.ticketSubmittedDesc': 'Ваш тикет #{ticketNumber} је послат. Молимо вас да се пријавите да бисте пратили своје тикете.',
    'support.toast.ticketSubmittedGuest': 'Ваш тикет је послат. Молимо вас да се пријавите да бисте пратили своје тикете.',
    'support.toast.authRequired': 'Потребна је аутентификација',
    'support.toast.authRequiredDesc': 'Молимо вас да се пријавите да бисте поднели тикет за подршку, или покушајте поново као гост.',
    'support.toast.error': 'Грешка',
    'support.toast.errorDesc': 'Слање тикета за подршку није успело. Покушајте поново.',
  },
  pl: {
    'support.back': 'Wstecz',
    'support.title': 'Centrum Wsparcia',
    'support.subtitle': 'Uzyskaj pomoc dotyczącą swojego konta i transakcji',
    'support.responseTime': 'Czas Odpowiedzi 24h',
    'support.systemStatus': 'Status Systemu',
    'support.allSystemsOperational': 'Wszystkie systemy działają',
    'support.helpCenter': 'Centrum Pomocy',
    'support.helpCenterDesc': 'Przeglądaj FAQ i przewodniki',
    'support.emailSupport': 'Wsparcie Email',
    'support.submitTicket': 'Zgłoś Bilet',
    'support.submitTicketDesc': 'Utwórz żądanie wsparcia',
    'support.ticketsTitle': 'Bilety Wsparcia',
    'support.ticketsDesc': 'Zgłoś nowe bilety lub zobacz swoje istniejące żądania wsparcia',
    'support.newTicket': 'Nowy Bilet',
    'support.myTickets': 'Moje Bilety',
    'support.guestSubmission': 'Zgłoszenie Gościa',
    'support.guestSubmissionDesc': 'Wysyłasz jako gość. {loginLink}, aby śledzić swoje bilety.',
    'support.login': 'Zaloguj się',
    'support.category': 'Kategoria',
    'support.priority': 'Priorytet',
    'support.subject': 'Temat',
    'support.subjectPlaceholder': 'Krótki opis Twojego problemu',
    'support.message': 'Wiadomość',
    'support.messagePlaceholder': 'Proszę podać szczegółowe informacje o Twoim problemie...',
    'support.submitting': 'Wysyłanie...',
    'support.submit': 'Zgłoś Bilet',
    'support.pleaseLogin': 'Proszę {loginLink}, aby zobaczyć swoje bilety.',
    'support.loadingTickets': 'Ładowanie Twoich biletów...',
    'support.noTickets': 'Nie wysłałeś jeszcze żadnych biletów',
    'support.createFirstTicket': 'Utwórz Swój Pierwszy Bilet',
    'support.ticketDetail': 'Bilet #{ticketNumber}',
    'support.you': 'Ty',
    'support.resolvedMessage': 'Ten bilet został rozwiązany. Jeśli potrzebujesz dalszej pomocy, proszę utworzyć nowy bilet.',
    'support.toast.validationError': 'Błąd Walidacji',
    'support.toast.validationErrorDesc': 'Proszę podać zarówno temat, jak i wiadomość',
    'support.toast.success': 'Sukces',
    'support.toast.successDesc': 'Twój bilet wsparcia został wysłany. Odpowiemy w ciągu 24 godzin.',
    'support.toast.ticketSubmitted': 'Bilet Wysłany',
    'support.toast.ticketSubmittedDesc': 'Twój bilet #{ticketNumber} został wysłany. Proszę zalogować się, aby śledzić swoje bilety.',
    'support.toast.ticketSubmittedGuest': 'Twój bilet został wysłany. Proszę zalogować się, aby śledzić swoje bilety.',
    'support.toast.authRequired': 'Wymagana Autentykacja',
    'support.toast.authRequiredDesc': 'Proszę zalogować się, aby wysłać bilet wsparcia, lub spróbować ponownie jako gość.',
    'support.toast.error': 'Błąd',
    'support.toast.errorDesc': 'Nie udało się wysłać biletu wsparcia. Proszę spróbować ponownie.',
  },
};
